export class DrillSessionQuotaExceededError extends Error {
    readonly code = "DRILL_SESSION_QUOTA_EXCEEDED";
    readonly drillId: string;
    readonly executionsUsed: number;
    readonly executionsLimit: number;

    constructor(drillId: string, executionsUsed: number, executionsLimit: number) {
        super("DRILL_SESSION_QUOTA_EXCEEDED");
        this.name = "DrillSessionQuotaExceededError";
        this.drillId = drillId;
        this.executionsUsed = executionsUsed;
        this.executionsLimit = executionsLimit;
    }
}

export function isDrillSessionQuotaExceededError(
    error: unknown
): error is DrillSessionQuotaExceededError {
    return error instanceof DrillSessionQuotaExceededError;
}
